import React, { FC } from 'react';

const ShortTextIcon: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <svg
      width="130"
      height="88"
      viewBox="0 0 130 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="129.333" height="88" rx="8" fill="#E9F2FB" />
      <path
        d="M16 16C16 13.7909 17.7909 12 20 12H109C111.209 12 113 13.7909 113 16V85H16V16Z"
        fill="white"
      />
      <rect x="26" y="23" width="34" height="34" rx="2" fill="#F7F7F7" />
      <rect x="26" y="60" width="34" height="14" rx="2" fill="#F7F7F7" />
      <path
        d="M67.4008 23.83V24.388H66.2908V28H65.6068V24.388H64.4908V23.83H67.4008ZM68.4416 24.256C68.3176 24.256 68.2136 24.214 68.1296 24.13C68.0456 24.046 68.0036 23.942 68.0036 23.818C68.0036 23.694 68.0456 23.59 68.1296 23.506C68.2136 23.422 68.3176 23.38 68.4416 23.38C68.5616 23.38 68.6636 23.422 68.7476 23.506C68.8316 23.59 68.8736 23.694 68.8736 23.818C68.8736 23.942 68.8316 24.046 68.7476 24.13C68.6636 24.214 68.5616 24.256 68.4416 24.256ZM68.7776 24.694V28H68.0936V24.694H68.7776ZM70.4736 25.252V27.082C70.4736 27.206 70.5016 27.296 70.5576 27.352C70.6176 27.404 70.7176 27.43 70.8576 27.43H71.2776V28H70.7376C70.4296 28 70.1936 27.928 70.0296 27.784C69.8656 27.64 69.7836 27.406 69.7836 27.082V25.252H69.3936V24.694H69.7836V23.872H70.4736V24.694H71.2776V25.252H70.4736ZM72.592 23.56V28H71.908V23.56H72.592ZM76.52 26.266C76.52 26.39 76.512 26.502 76.496 26.602H73.97C73.99 26.866 74.088 27.078 74.264 27.238C74.44 27.398 74.656 27.478 74.912 27.478C75.28 27.478 75.54 27.324 75.692 27.016H76.43C76.33 27.32 76.148 27.57 75.884 27.766C75.624 27.958 75.3 28.054 74.912 28.054C74.596 28.054 74.312 27.984 74.06 27.844C73.812 27.7 73.616 27.5 73.472 27.244C73.332 26.984 73.262 26.684 73.262 26.344C73.262 26.004 73.33 25.706 73.466 25.45C73.606 25.19 73.8 24.99 74.048 24.85C74.3 24.71 74.588 24.64 74.912 24.64C75.224 24.64 75.502 24.708 75.746 24.844C75.99 24.98 76.18 25.172 76.316 25.42C76.452 25.664 76.52 25.946 76.52 26.266ZM75.806 26.05C75.802 25.798 75.712 25.596 75.536 25.444C75.36 25.292 75.142 25.216 74.882 25.216C74.646 25.216 74.444 25.292 74.276 25.444C74.108 25.592 74.008 25.794 73.976 26.05H75.806Z"
        fill="black"
      />
      <rect x="64" y="32" width="43" height="2" rx="1" fill="#D9D9D9" />
      <rect x="64" y="35" width="38" height="2" rx="1" fill="#D9D9D9" />
      <rect x="64" y="38" width="43" height="2" rx="1" fill="#D9D9D9" />
      <rect x="64" y="41" width="41" height="2" rx="1" fill="#D9D9D9" />
      <rect x="64" y="46" width="26" height="9" rx="2" fill="#F7F7F7" />
      <rect x="64" y="58" width="16" height="12" rx="2" fill="#F7F7F7" />
    </svg>
  );
};

export default ShortTextIcon;
